import React from 'react'

import { useNavigation } from '@zet/common/hooks/useNavigation'
import {
  Icon,
  Pressable,
  SH2,
  SH3,
  Stack,
  XStack,
  YStack,
} from '@zet/design-system'
import { useUserContext } from '@zet/feature-user'
import { i18n } from '@zet/localization'
import { IDCardIcon } from '@zet/svg'

const UserIdCard = () => {
  const { data } = useUserContext()
  const { navigate } = useNavigation()

  const handlePress = () => {
    navigate('IdCard')
  }

  return (
    <YStack className="mt-3 px-3">
      <Stack>
        <SH2 className="text-grays-100">{i18n.t('joiningKit.myIdCard')}</SH2>
      </Stack>
      <Pressable
        className="bg-grays-20 my-3 rounded-lg p-3"
        onPress={handlePress}
      >
        <XStack className="items-center justify-between">
          <XStack className="items-center space-x-2">
            <IDCardIcon />
            <SH3 className="text-grays-80">{data?.companyName}</SH3>
          </XStack>
          <Stack>
            <Icon type="ArrowRight" />
          </Stack>
        </XStack>
      </Pressable>
    </YStack>
  )
}

export default UserIdCard
